/**
 * @Description 标准版-选址地图拓店任务-相关接口
 */

import { post } from '@/common/request/index';

/**
 * @description 待发起列表
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/71665
 */
export function taskClusterList(params?: any) {
  return post('/standard/taskCluster/list', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 添加到待发起列表
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/71672
 */
export function taskClusterAdd(params?: any) {
  return post('/standard/taskCluster/add', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 从待发起列表删除
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/71679
 */
export function taskClusterDelete(params?: any) {
  return post('/standard/taskCluster/delete', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 创建任务
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/72302
 */
export function taskClusterTaskCreate(params?: any) {
  return post('/standard/taskCluster/task/create', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description （单条）一次/二次/三次-快速创建拓店任务审批
 * （前端备注：选址地图详情-一次/二次/三次指派方式，走审批时都用这个接口）
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/84013
 */
export function taskClusterFastApproval(params?: any) {
  return post('/standard/taskCluster/fast/approval', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 三次指派-不审批直接添加待指派开发主管列表
 *      （前端备注：选址地图批量发起、单条发起任务时，不走审批时都用这个接口）
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/84076
 */
export function taskClusterBatchOrFastAdd(params?: any) {
  return post('/standard/taskCluster/pending/batchAdd', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 三次指派-待指派开发主管列表（前端备注：备选区域列表页用）
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/84062
 */
export function taskClusterPage(params?: any) {
  return post('/standard/taskCluster/pending/page', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 三次指派-备选区域待指派个数
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/85686
 */
export function taskClusterPendingCount(params?: any) {
  return post('/standard/taskCluster/pending/count', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 三次指派-备选区域批量指派主管（前端备注：备选区域列表页用）
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/84034
 */
export function taskClusterAssign(params?: any) {
  return post('/standard/taskCluster/pending/assign/task', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 三次指派-备选区域指派主管审批-创建拓店任务审批（前端备注：备选区域列表页用）
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/84027
 */
export function taskClusterAssignApproval(params?: any) {
  return post('/standard/taskCluster/pending/assign/approval', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}
